import './BottomDrawer.css';
import ProgressPanel from './components/ProgressPanel';

export default function BottomDrawer({ disableToggle, isOpen, onToggle }) {
    return (
        <div className={`bottom-drawer ${isOpen ? 'open' : ''}`}>
            <div className={`drawer-toggle ${disableToggle ? 'disabled' : ''}`} onClick={disableToggle ? undefined : onToggle}>
                {isOpen ? '▼' : '▲'}
            </div>
            {isOpen && (
                <div className="drawer-bottom-content">
                    <ProgressPanel />
                </div>
            )}
        </div>
    );
};

